var map = {
	"./DecipherNotes-admin.webp": 783,
	"./DecipherNotes.webp": 479,
	"./companion-android.webp": 51,
	"./companion-calls.webp": 520,
	"./companion-dashboard.webp": 529,
	"./companion-settings.webp": 646,
	"./companion-share.webp": 398,
	"./companion-signin.webp": 699,
	"./nuro-activities-word-identification.webp": 977,
	"./nuro-activities.webp": 816,
	"./nuro-add-task.webp": 953,
	"./nuro-cards.webp": 716,
	"./nuro-decks.webp": 474,
	"./nuro-edit-task.webp": 70,
	"./nuro-help.webp": 951,
	"./nuro-schedule.webp": 413,
	"./nuro-train.webp": 770,
	"./pomodoro-settings.webp": 337,
	"./pomodoro.webp": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;